module.exports = __webpack_public_path__ + "img/banner.036efcf1.jpg";